<%= form_with(model: payment, class: "contents") do |form| %>
  <% if payment.errors.any? %>
    <div id="error_explanation" class="bg-red-50 text-red-500 px-3 py-2 font-medium rounded-md mt-3">
      <h2><%= pluralize(payment.errors.count, "error") %> prohibited this payment from being saved:</h2>

      <ul class="list-disc ml-6">
        <% payment.errors.each do |error| %>
          <li><%= error.full_message %></li>
        <% end %>
      </ul>
    </div>
  <% end %>

  <div class="my-5">
    <%= form.label :person_id %>
    <%= form.text_field :person_id, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": payment.errors[:person_id].none?, "border-red-400 focus:outline-red-600": payment.errors[:person_id].any?}] %>
  </div>

  <div class="my-5">
    <%= form.label :amount %>
    <%= form.text_field :amount, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": payment.errors[:amount].none?, "border-red-400 focus:outline-red-600": payment.errors[:amount].any?}] %>
  </div>

  <div class="my-5">
    <%= form.label :date %>
    <%= form.date_field :date, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": payment.errors[:date].none?, "border-red-400 focus:outline-red-600": payment.errors[:date].any?}] %>
  </div>

  <div class="my-5">
    <%= form.label :comment %>
    <%= form.textarea :comment, rows: 4, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": payment.errors[:comment].none?, "border-red-400 focus:outline-red-600": payment.errors[:comment].any?}] %>
  </div>

  <div class="inline">
    <%= form.submit class: "w-full sm:w-auto rounded-md px-3.5 py-2.5 bg-blue-600 hover:bg-blue-500 text-white inline-block font-medium cursor-pointer" %>
  </div>
<% end %>
